import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Link} from "react-router-dom";
import { getAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { ConditionalBlock } from "../../../ConditionalBlock";
import { transformBlankToNull } from "../../../services/Util";


export default function LeveragedTm(prop) {
        
    const navigate = useNavigate();
    const [showAssets, setShowAssets] =  useState(false);
    const [targetLanguage, setTargetLanguage] =  useState(false);
    const [assetsTodisplay, setAssetsToDisplay] =  useState([]);
    function viewLeveragedTm(projectAssetId){        
        navigate(`/leveraged-tm/${prop.projectDetail.resource.projectResource.id}/${projectAssetId}/${targetLanguage}`);
    }

    function listAssets(langCode){

        getAxiosResponse(APIUrls.CUSTOMER_TARGET_ASSET_FOR_PROJECT_AND_LANGUAGE_CODE(prop.projectDetail.resource.projectResource.id, langCode))
      .then((res) => {
        if (res.data !== "") {          
          let targetAssetsByLanguage = transformBlankToNull(res.data.data);                        
          let sourceAssetIdsByLanguage =  targetAssetsByLanguage.map(targetAssetsByLanguage=>targetAssetsByLanguage.sourceProjectAssetId)          
          let sourceAssets = prop.projectDetail.resource.projectResource.projectAssets;          

          sourceAssets = sourceAssets.map(sourceAsset=> {  
            let asset = {...sourceAsset};
            let filteredTargetAsset = targetAssetsByLanguage.find(targetAsset=>{                           
              if(asset.id == targetAsset.sourceProjectAssetId){
                    return targetAsset;
              }
            });                                 

            if(filteredTargetAsset){
              asset.leveragedWordCount = filteredTargetAsset.leveragedWordCount;
              asset.translatedWordCount = filteredTargetAsset.wordCount;
              asset.averageQualityScore = filteredTargetAsset.averageQualityScore;
            }
            
            return asset;
          })
          let filteredSourceAssets = sourceAssets.filter(sourceAsset=> sourceAssetIdsByLanguage.includes(sourceAsset.id));
          setAssetsToDisplay(filteredSourceAssets);
          setShowAssets(true);
          setTargetLanguage(langCode);        
        }
      })
        
        
    }

    return (
        <div>
            
            { !showAssets && prop.projectDetail.displayName[0].targetLanguages && prop.projectDetail.displayName[0].targetLanguages?.length !== 0 && (
            <div className="detail-header flex-center">
              <div className="detail-header-left">
                <div className="translate-box flex">
                  {prop.projectDetail.displayName[0].targetLanguages.map(
                    (lang, targetLangindex) => {
                      return (
                        <div
                          className="translate-box-list"                          
                          id={lang.code}
                          key={targetLangindex}
                          role="none"
                        >
                          <Link
                            to="#"
                            role="button"                            
                            onClick={() => listAssets(lang.code)}
                            projectdetail-tour="expand-lang"
                          >
                            {lang.language}                            
                          </Link>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>              
            </div>
          ) }

          {showAssets && <div class="white-bg">
   <div class="table-responsive global-table">
      <table class="sortable" aria-label="Translation Memory">
         <tr>
            <th aria-label="Asset" scope="col" class="link-color">Asset</th>                      
            <th aria-label="Total Word Count" scope="col" class="link-color">Total Word Count  (Translated) </th>                        
            <th aria-label="Leveraged Word Count" scope="col" class="link-color">Leveraged Word Count</th>                                    
            <th aria-label="Action" scope="col" class="link-color">Action</th>
         </tr>
         <tbody>
            { assetsTodisplay.map(projectAsset=> <tr>                               
               <td>{projectAsset.assets.filter((asset)=>asset.name!==null && asset.name!=="")[0].name}</td>                             
               <td>{projectAsset.translatedWordCount?projectAsset.translatedWordCount:0}</td>                
               <td>{projectAsset.leveragedWordCount?projectAsset.leveragedWordCount:0}</td>                                                                                        
               <td>
               <ConditionalBlock condition={projectAsset.leveragedWordCount == null || projectAsset.leveragedWordCount == 0}>
                 NA
                </ConditionalBlock>
                <ConditionalBlock condition={(projectAsset.leveragedWordCount !== null && projectAsset.leveragedWordCount !== 0)}>
                <button className="blue-btn" onClick={()=>{viewLeveragedTm(projectAsset.id)}}>View Leveraged TMs</button>
                </ConditionalBlock>
                </td>               
            </tr> )}
            
         </tbody>
      </table>      
      
   </div>
</div>}                
        </div>
    )
}